import { useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { mustBeSubscriptionOwner } from "./useRedirectIfDisallowed";
import { useMemo } from "react";
import { StripeStatus } from "views/page-content/platforms/types";
import { usePauseStatus } from "./usePauseStatus";

export const useUserStatus = () => {
    const { userInfo, defaultOrg } = useSelector((s: RootState) => s.user);

    const userStatusIsActive = useMemo<boolean>(
        () => userInfo?.Plan?.Details?.Status === StripeStatus.Active,
        [userInfo]
    );

    const userStatusIsTrialing = useMemo<boolean>(
        () => userInfo?.Plan?.Details?.Status === StripeStatus.Trialing,
        [userInfo]
    );

    const userPlanIsTrial = useMemo<boolean>(
        () =>
            userInfo?.Plan?.Details?.Name === "Trial" &&
            !userInfo?.Claims?.Details?.FeatureClaims.includes("nowatermark"),
        [userInfo]
    );

    const userHasNoSubscription = useMemo<boolean>(
        () => userInfo?.Plan?.Details?.Name === "No Subscription",
        [userInfo?.Plan?.Details?.Name]
    );

    const { userIsOrWillPause: userHasPausedV2 } = usePauseStatus();

    const userIsPaused = useMemo<boolean>(
        () =>
            userInfo.Claims?.Details?.Roles.includes("Paused") &&
            mustBeSubscriptionOwner({
                defaultOrg,
                userInfo
            }),
        [defaultOrg, userInfo]
    );

    return {
        userStatusIsActive,
        userStatusIsTrialing,
        userPlanIsTrial,
        userHasNoSubscription,
        userIsPaused,
        userHasPausedV2
    };
};
